module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[76]563.edd0a99.woff2";